/* UmproTech Stage 11 — public industrial tracking runtime.
   Public storefront only. No capture-phase hijack, no preventDefault, no Shopify editor analytics pollution. */
(function(){
  if (window.__utIndustrialPlatformRuntime) return;
  window.__utIndustrialPlatformRuntime = true;

  function inDesignMode(){ return !!(window.Shopify && window.Shopify.designMode); }
  function cleanText(value){ return (value || '').replace(/\s+/g, ' ').trim().slice(0, 140); }
  function hasAnalytics(){ return !!(window.gtag || window.dataLayer || window.fbq); }

  function sendEvent(name, params){
    if (inDesignMode() || !name) return;
    params = params || {};
    params.page_location = window.location.href;
    params.page_path = window.location.pathname;
    params.page_type = (document.body && document.body.getAttribute('data-page-type')) || '';
    params.template_suffix = (document.body && document.body.getAttribute('data-template-suffix')) || '';

    try { if (window.gtag) window.gtag('event', name, params); } catch(e) {}
    try { if (window.dataLayer && Array.isArray(window.dataLayer)) window.dataLayer.push(Object.assign({event:name}, params)); } catch(e) {}
    try { if (window.fbq) window.fbq('trackCustom', name, params); } catch(e) {}
  }

  function classifyLink(anchor){
    var href = anchor.getAttribute('href') || '';
    var text = cleanText(anchor.textContent).toLowerCase();
    if (!href && !text) return null;
    if (href.indexOf('/pages/request-industrial-equipment-quote') >= 0 || href.indexOf('machine-quote-center-usa') >= 0 || text.indexOf('quote') >= 0 || text.indexOf('rfq') >= 0 || text.indexOf('request pricing') >= 0) return 'rfq_click';
    if (href.indexOf('/pages/equipment-financing-options') >= 0 || text.indexOf('financing') >= 0 || text.indexOf('finance') >= 0) return 'financing_click';
    if (href.indexOf('tel:') === 0) return 'phone_click';
    if (href.indexOf('mailto:') === 0) return 'email_click';
    if (text.indexOf('schedule demo') >= 0 || href.indexOf('schedule-demo') >= 0 || href.indexOf('demo') >= 0) return 'schedule_demo_click';
    return null;
  }

  document.addEventListener('click', function(event){
    var anchor = event.target && event.target.closest && event.target.closest('a[href]');
    if (!anchor) return;
    var eventName = classifyLink(anchor);
    if (!eventName) return;
    sendEvent(eventName, {
      link_text: cleanText(anchor.textContent),
      link_url: anchor.getAttribute('href') || '',
      component: anchor.closest('.ut-usa-dock') ? 'conversion_dock' : (anchor.closest('header') ? 'header' : (anchor.closest('footer') ? 'footer' : 'content'))
    });
  }, false);

  document.addEventListener('submit', function(event){
    var form = event.target;
    if (!form || !form.matches) return;
    var isQuoteForm = form.matches('.ut-rq-form,[data-umpro-rfq-form],form[action*="/contact"]') && (
      form.classList.contains('ut-rq-form') ||
      form.hasAttribute('data-umpro-rfq-form') ||
      !!form.querySelector('input[name="contact[Source URL]"],input[name="contact[Product]"],input[name="contact[Machine]"]')
    );
    if (!isQuoteForm) return;
    sendEvent('quote_form_submit', { form_id: form.getAttribute('id') || form.getAttribute('data-umpro-form-id') || 'quote-contact-form' });
  }, false);

  function successCheck(){
    if (document.querySelector('[data-umpro-quote-success],.form-status-success,.contact__button + .form-status')) {
      sendEvent('quote_form_success', { form_id:'quote-contact-form' });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', successCheck); else successCheck();
})();
